import { alpha, Button, Grid, Stack } from "@mui/material";
import { CSSProperties, useContext } from "react";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Context from "../../../../context";
import InfoTitle from "../InfoTitle";

// ----------------------------------------------------------------------

type Props = {
	title: string;
};

export const InfoHeader = ({ title }: Props) => {
	const { actions, theme, state } = useContext(Context);
	const isMobile = useResponsive("down", "sm");

	const { translate } = useLocales();

	const buttonStyle: CSSProperties = {
		borderRadius: theme?.button.shape,
		backgroundColor: theme?.colors.buttonBackground,
		color: theme?.colors.buttonText,
		fontWeight: theme?.button.textWeight === "BOLD" ? 700 : 500,
		boxShadow: `0 8px 16px 0 ${alpha(theme?.colors.buttonBackground ?? "", 0.24)}`
	};

	return (
		<Grid item xs={12} sm={6}>
			<Stack sx={{ justifyContent: "space-between", height: "100%" }}>
				<InfoTitle title={title} />
				{!isMobile && (
					<Button
						variant='contained'
						size='large'
						style={buttonStyle}
						sx={{ mb: 0.4, maxWidth: 190 }}
						onClick={() => actions.setStep(state.entity?.id ? 2 : 1)}
					>
						{translate("info_panel.connect_my_account")}
					</Button>
				)}
			</Stack>
		</Grid>
	);
};

export default InfoHeader;
